import {
  Header as RACHeader,
  ListBox as RACListBox,
  ListBoxItem as RACListBoxItem,
  type ListBoxItemProps as RACListBoxItemProps,
  type ListBoxProps as RACListBoxProps,
  ListBoxSection as RACListBoxSection,
  type ListBoxSectionProps as RACListBoxSectionProps,
} from "react-aria-components";

export interface ListBoxProps<T extends object> extends RACListBoxProps<T> {}
export interface ListBoxItemProps extends RACListBoxItemProps {}
export interface ListBoxSectionProps<T extends object> extends RACListBoxSectionProps<T> {}
export type ListBoxHeaderProps = React.ComponentPropsWithoutRef<typeof RACHeader>;

export function ListBox<T extends object>(props: ListBoxProps<T>) {
  return <RACListBox {...props} />;
}

export function ListBoxItem(props: ListBoxItemProps) {
  return <RACListBoxItem {...props} />;
}

export function ListBoxSection<T extends object>(props: ListBoxSectionProps<T>) {
  return <RACListBoxSection {...props} />;
}

export function ListBoxHeader(props: ListBoxHeaderProps) {
  return <RACHeader {...props} />;
}
